/* Custom elements reconnect automatically when Shopify's editor replaces a section. */
(() => {
  function launchTimestamp(value) {
    const match = /^(\d{4}-\d{2}-\d{2})T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/.exec(value || '');
    if (!match) return NaN;
    const calendarDate = new Date(`${match[1]}T00:00:00Z`);
    if (!Number.isFinite(calendarDate.getTime()) || calendarDate.toISOString().slice(0, 10) !== match[1]) return NaN;
    return Date.parse(value);
  }
  function countdownParts(milliseconds) {
    const total = Math.max(0, Math.ceil(milliseconds / 1000));
    return { days: Math.floor(total / 86400), hours: Math.floor(total / 3600) % 24, minutes: Math.floor(total / 60) % 60, seconds: total % 60 };
  }
  class CustomLaunch extends HTMLElement {
    connectedCallback() {
      this.end = launchTimestamp(this.dataset.launchAt);
      this.update();
      if (this.dataset.state === 'automatic' && Number.isFinite(this.end) && this.end > Date.now()) {
        this.interval = window.setInterval(() => this.update(), 1000);
      }
    }
    disconnectedCallback() { window.clearInterval(this.interval); }
    update() {
      const valid = Number.isFinite(this.end);
      const live = this.dataset.state === 'live' || (this.dataset.state === 'automatic' && valid && Date.now() >= this.end);
      this.querySelectorAll('[data-coming]').forEach(node => { node.hidden = live; });
      this.querySelectorAll('[data-live]').forEach(node => { node.hidden = !live; });
      const error = this.querySelector('[data-date-error]');
      if (error) error.hidden = valid || this.dataset.state !== 'automatic';
      const parts = countdownParts(this.end - Date.now());
      this.querySelectorAll('[data-unit]').forEach(node => {
        node.textContent = valid ? String(parts[node.dataset.unit]).padStart(2, '0') : '—';
      });
      if (live && !this.live) {
        const announcement = this.querySelector('[data-launch-announcement]');
        if (announcement) announcement.textContent = announcement.dataset.message;
        window.clearInterval(this.interval);
      }
      this.live = live;
    }
  }
  if (!customElements.get('custom-launch')) customElements.define('custom-launch', CustomLaunch);
  class CustomNavigation extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const wrapper = this.closest('.custom-navigation-section');
      this.sizeObserver?.disconnect();
      this.sizeObserver = new ResizeObserver(() => {
        wrapper?.style.setProperty('--custom-navigation-height', `${this.offsetHeight}px`);
      });
      this.sizeObserver.observe(this);
      this.headerObserver?.disconnect();
      const header = document.querySelector('.section-header');
      this.headerObserver = new MutationObserver(() => {
        if (header.classList.contains('shopify-section-header-hidden')) this.closeAll();
      });
      if (header) this.headerObserver.observe(header, { attributes: true, attributeFilter: ['class'] });
      this.addEventListener('toggle', event => {
        const details = event.target;
        if (!details.matches('details')) return;
        if (details.open) {
          // Close only siblings; opening a child must leave its ancestors open.
          for (const item of details.parentElement.parentElement.children) {
            const sibling = item.querySelector(':scope > details');
            if (sibling && sibling !== details) this.close(sibling);
          }
          this.position(details);
        } else {
          details.querySelectorAll('details[open]').forEach(child => this.close(child));
        }
      }, { capture: true, signal });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const details = event.target.closest('details[open]');
        if (!details) return;
        event.preventDefault();
        this.close(details);
        details.querySelector('summary').focus();
      }, { signal });
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.closeAll();
      }, { signal });
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) this.closeAll();
      }, { signal });
      window.addEventListener('resize', () => {
        this.querySelectorAll('.custom-navigation__disclosure--root[open]').forEach(details => this.position(details));
      }, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.sizeObserver?.disconnect();
      this.headerObserver?.disconnect();
    }
    close(details) {
      details.open = false;
      details.querySelectorAll('details[open]').forEach(child => { child.open = false; });
    }
    closeAll() {
      this.querySelectorAll('.custom-navigation__disclosure--root[open]').forEach(details => this.close(details));
    }
    position(details) {
      if (!details.classList.contains('custom-navigation__disclosure--root')) return;
      const panel = details.querySelector(':scope > .custom-navigation__submenu');
      panel.style.setProperty('--custom-menu-shift', '0px');
      const bounds = panel.getBoundingClientRect();
      const shift = Math.max(16 - bounds.left, Math.min(0, document.documentElement.clientWidth - 16 - bounds.right));
      panel.style.setProperty('--custom-menu-shift', `${shift}px`);
    }
  }
  if (!customElements.get('custom-navigation')) customElements.define('custom-navigation', CustomNavigation);
})();
